/**
  * 合同模块接口列表
*/
import axios from './http'; // 导入http中创建的axios实例
import qs from 'qs'; // 根据需求是否导入qs模块

const contract = {
  //获取最新合同ID
  getContractMaxRev(params){
    return axios.get('/contractmanager/contractManager/getContractMaxRev',{params:params});
  },
  //保存自营申报简表
  saveDeclarationForm(params){
    return axios.post('/contractmanager/contractManager/vssCreateContract',params);
  },
  //保存自营申报简表(new)
  saveDeclarationFormNew(params){
    return axios.post('/contractmanager/contractManager/vssCreateContractNew',params);
  },
  // 获取供应商默认值
  getDefaultValue(params){
    return axios.post('/scm-supp/supplier/selectComposite',params);
  },
  // 电子合同管理-全部
  getDeclaration(params){
    return axios({
      method: 'post',
      url: "/contractmanager/contractManager/showVssContractInfo",
      data: qs.stringify(params),
      timeout: 1000 * 60 * 2,
    });
  },
  // 电子合同管理-待签章
  getVssToBeSigned(params){
    return axios.post('/contractmanager/contractManager/showVssToBeSigned',qs.stringify(params));
  },
  //保存促销协议
  savePromotionAgreement(params){
    return axios.post('/contractmanager/contractManager/savePromotionAgreement',params);
  },
  // 促销协议
  getPromotionAgreement(params){
    return axios.post('/contractmanager/cmxPromotionAgreement/insertStoresCmxPromotionAgreement',qs.stringify(params))
  },
  // 采购协议
  savePurchaseAgreement(params){
    return axios.post('/contractmanager/cmxPurchaseAgreement/insertStoresCmxPurchaseAgreement',qs.stringify(params))
  },
	//获取采购协议列表
	getPurchaseAgreement(params){
	  return axios.post('/contractmanager/cmxPurchaseAgreement/getCmxPurchaseAgreementPage',qs.stringify(params))
	},
	//删除采购协议列表
	delCmxPurchaseAgreement(params){
	  return axios.post('/contractmanager/cmxPurchaseAgreement/deleteCmxPurchaseAgreement',qs.stringify(params))
	},
	//修改采购协议列表
	updateCmxPurchaseAgreement(params){
	  return axios.post('/contractmanager/cmxPurchaseAgreement/updateCmxPurchaseAgreement',qs.stringify(params))
	},
  //  查看申报简表
  getVssContractInfo(params){
    return axios.get("/contractmanager/contractManager/getVssContractInfo",{params:params})
  },
  // 查看促销协议
  getCmxPromotionAgreement(params){
    return axios.get("/contractmanager/contractManager/getPromotionAgreement",{params:params})
  },
  // 修改促销协议
  updateCmxPromotionAgreement(params){
    return axios.post("/contractmanager/cmxPromotionAgreement/updateCmxPromotionAgreement",qs.stringify(params))
  },
	// 获取商品信息
	getItemMaster(params){
	  return axios.post("/commoditymanagement/itemMaster/showItemMaster",qs.stringify(params))
	},
	// 提交合同状态
	updateContractStatus(params){
		return axios.post("/contractmanager/contractManager/vssSubmit",qs.stringify(params))
  },
  // //////////////////////////////////申报简表////////////////////////////////////
  // 申报简表-编辑
  updatevssContract(params){
		return axios.post("/contractmanager/contractManager/vssUpdateContract",params)
  },
  // 申报简表-编辑(new)
  updatevssContractNew(params){
		return axios.post("/contractmanager/contractManager/vssUpdateContractNew",params)
  },
  // //////////////////////////////////年度促销计划///////////////////////////////
  // 年度计划列表接口-查询
  getCmxPromotionPlanPage(params){
		return axios.post("/contractmanager/cmxPromotionPlan/getCmxPromotionPlan",qs.stringify(params))
  },
  // 年度计划列表接口-删除(新)
  getDeleteBatchIds(params){
		return axios.post("/contractmanager/cmxPromotionPlan/deleteBatchIds",params)
  },
  // 年度计划列表接口-删除
  // deleteCmxPromotionPlan(params){
	// 	return axios.post("/contractmanager/cmxPromotionPlan/deleteBatchIds",params)
  // },
  // //////////////////////////////////采购协议接口///////////////////////////////////////////////
  // 采购协议-是否裸价-是否联采 修改
  updateCmxPurchaseAgreement(params){
		return axios.post("/contractmanager/contractManager/savePurchaseAgreement",qs.stringify(params))
  },
  // 采购协议-是否裸价-是否联采(查询)
  getCmxPurchaseAgreement(params){
		return axios.get("/contractmanager/contractManager/getPurchaseAgreement", {params:params})
  },
  // 采购协议列表查询(新)
  getCmxPurchaseAgreementDetailPage(params){
		return axios.post("/contractmanager/cmxPurchaseAgreementDetail/getCmxPurchaseAgreementDetailPage",qs.stringify(params))
  },
  // 采购协议列表批量删除(新)
  deleteCmxPurchaseAgreementDetail(params){
		return axios.post("/contractmanager/cmxPurchaseAgreementDetail/deleteBatchIds",params)
  },
  

  // 救火版接口
  // 列表查询
	getCmxContractPage(params){
		return axios.post("/contractmanager/cmxContract/getCmxContractPage",qs.stringify(params))
  },
  //预览签章时查询tab信息
  getArchivesByContractLocalid(params){
    return axios.post('/contractmanager/cmxContractArchives/getArchivesByContractLocalid',qs.stringify(params));
       
  },
  //文件下载
  downloadFile(params){
    return axios.get('/contractmanager/wordAndPdfController/downZipFile', params);
    
  },
   //预览文件
  getElectronicFiles(params){
    return axios.post("/contractmanager/cmxContractArchives/getElectronicFiles",qs.stringify(params));
  },

  //取消合同
  cancelContract(params){
   return axios.post("/contractmanager/contractManager/cancelContract",qs.stringify(params));
 },

  //-------------------------------合同盖章-------------------------------------
  //退出签章
  exitSignature(params){
    return axios.post('/contractmanager/contractManager/exitSignature',qs.stringify(params));
  },
  //锁定签章
  blockSignature(params){
    return axios.post('/contractmanager/contractManager/blockSignature',qs.stringify(params));
  },
  //合同文件盖章
  contractFileStamp(params){
    return axios.post('/contractmanager/contractManager/contractFileStamp',qs.stringify(params));
  },
  //提交签章
  submitSignature(params){
    return axios.post('/contractmanager/contractManager/submitSignature',qs.stringify(params));
  },

  //----------------------跨年合同-----------------------------
  //查询合同可选结束时间列表及合同年份
  getDateInfoByStartDate(params){
    return axios.post('/contractmanager/contractManager/getDateInfoByStartDate',qs.stringify(params));
  },

  //--------------------------签章--------------------------------
  //查询用户
  userFind: (params)=>{
    return axios.get("/signaturemanager/signature/findTrustsignUser", {params:params})
  },
  //注册用户
  userCreate: (params)=>{
    return axios.post("/signaturemanager/signature/createUser", qs.stringify(params));
  },
  //导入数字证书
  certificateImport: (params)=>{
    return axios.post("/signaturemanager/signature/importCertificate", qs.stringify(params));
  },
  //获取文档待签数据
  fileDigest: (params)=>{
    return axios.post("/signaturemanager/signature/filedigest", qs.stringify(params));
  },
  //签章就绪
  signatureReady: (params) =>{
    return axios({
      method: 'post',
      url: "/signaturemanager/signature/signatureReady",
      data: qs.stringify(params),
      timeout: 1000 * 60 * 10,
    });
  },
  //合成签章文档
  filemerge: (params)=>{
    return axios.post("/signaturemanager/signature/filemerge", qs.stringify(params));
  },
  //ukey与用户一致性校验
  ukeyVerify: (params) => {
    return axios.get('/signaturemanager/signature/ukeyVerify', {params:params});
  }
};

export default contract;


// WEBPACK FOOTER //
// ./src/api/api_contract.js